module.exports = __webpack_public_path__ + "img/icon6.8c267f24.svg";